class FP_Demos {
	constructor() {
		this.wrapper = document.querySelector('.fp-demos');

		/**
		 * Modal
		 * 
		 * @var  {HTMLElement}
		 */
		this.modal = document.querySelector('.fp-demo-preview-modal');

		/**
		 * Whether the Previewer is open.
		 * 
		 * @var  {Boolean}
		 */
		this.previewing = false;

		/**
		 * Preview URL.
		 * 
		 * @var  {String}
		 */
		this.preview_url = this.modal.dataset.previewUrl;
		
		// Initial load
		this.updateFromURL();

		this.initEvents();
	}

	initEvents() {
		const self = this;

		window.onpopstate = function() {
			self.updateFromURL();
		}

		document.addEventListener('onFPDemoURLChange', function(e) {
			this.updateFromURL(e.detail.url);
		}.bind(this));

		document.addEventListener('click', e => {
			this.onTemplatePreview(e);
			this.onOpen(e);
			this.onClose(e);
			this.toggleResponsiveViewport(e);
			this.refreshDemo(e);
			this.resetSearch(e);
			this.onTriggerFilters(e);
		});
		
		document.addEventListener('change', e => {
			this.onSortingValueChange(e);
		});

		document.addEventListener('keydown', function(e) {
			this.onSearchEnter(e);
			this.handleEscapeClose(e);
		}.bind(this));
	}

	onTriggerFilters(e) {
		let trigger = e.target.closest('.fp-demos-trigger-filters');
		if (!trigger) {
			return;
		}

		e.preventDefault();

		if (trigger.dataset.state == 'on') {
			trigger.setAttribute('data-state', 'off');
			trigger.innerHTML = trigger.dataset.off;

			trigger.nextElementSibling.classList.remove('is-visible');
		} else {
			trigger.setAttribute('data-state', 'on');
			trigger.innerHTML = trigger.dataset.on;

			trigger.nextElementSibling.classList.add('is-visible');
		}
	}

	onSortingValueChange(e) {
		let select = e.target.closest('.fp-demos-header-actions-sorting');
		if (!select) {
			return;
		}

		let sorting = select.value;

		let url = new URL(window.location.href);

		url.searchParams.set('sorting', sorting);

		window.location.href = url;
	}

	resetSearch(e) {
		let btn = e.target.closest('.fp-demo-search-reset');
		if (!btn) {
			return;
		}

		let wrapper = btn.closest('.fp-demo-search');

		wrapper.querySelector('input').value = '';

		// Get the URL
		const currentURL = window.location.href;

		// Get new URL
		const newURL = currentURL.split('/search/')[0] + '/';

		// Redirect to new URL
		window.location.href = newURL;
	}

	onSearchEnter(e) {
		let input = e.target.closest('.fp-demo-search-input');
		if (!input) {
			return;
		}

		if (e.keyCode !== 13)
		{
			return;
		}
		
		e.preventDefault();
		
		let search_term = input.value.trim();

		if (search_term === '') {
			return;
		}

		// Get the URL
		const currentURL = window.location.href;

		let urlWithoutSearch = currentURL.split('/search/')[0];
		urlWithoutSearch = urlWithoutSearch.replace(/\/+$/, '');

		// Get the sorting
		let sortingValue = new URLSearchParams(window.location.search).get('sorting');
		
		// Remove query strings
		let currentUrlObj = new URL(urlWithoutSearch);
		currentUrlObj.search = '';

		let baseURL = currentUrlObj.href.replace(/\/+$/, '');

		// Get new URL
		let newURL = baseURL + '/search/' + encodeURIComponent(search_term);
		
		if (sortingValue) {
			newURL += '?sorting=' + sortingValue;
		}

		// Redirect to new URL
		window.location.href = newURL;
	}

	/**
	 * Custom Push State Event.
	 * 
	 * @param	{String}  state 
	 * @param	{String}  title 
	 * @param	{String}  url 
	 * 
	 * @return  void
	 */
	pushState(state, title, url) {
		let pushChangeEvent = new CustomEvent('onFPDemoURLChange', {
			detail: {
				state,
				title,
				url
			}
		});
		document.dispatchEvent(pushChangeEvent);
		return history.pushState(state, title, url);
	}

	/**
	 * Preview a template.
	 * 
	 * @param   {Event} e 
	 * 
	 * @return  void
	 */
	onTemplatePreview(e) {
		let btn = e.target.closest('.fp-demo-template-preview-trigger');
		if (!btn) {
			return;
		}
		
		e.preventDefault();

		this.pushState(null, null, '?id=' + btn.dataset.id);
	}

	/**
	 * On Modal Open event.
	 * 
	 * @param   {Event} e 
	 * 
	 * @return  void
	 */
	onOpen(e) {
		let btn = e.target.closest('.fp-demo-item-open-modal');
		if (!btn) {
			return;
		}
		
		e.preventDefault();

		let templateItem = btn.closest('.demo-item');

		let templateID = templateItem.dataset.id;

		this.pushState(null, null, '?id=' + templateID);
	}

	/**
	 * On Close Modal event.
	 * 
	 * @param   {Event} e 
	 * 
	 * @return  void
	 */
	onClose(e) {
		let btn = e.target.closest('.fp-demo-preview-close-modal');
		if (!btn) {
			return;
		}

		e.preventDefault();

		this.pushState(null, null, '?');
	}

	/**
	 * Callback that runs when the IFrame has loaded.
	 * 
	 * @return  void
	 */
	onIframeLoaded() {
		this.modal.classList.remove('refreshing');
	}

	/**
	 * Refresh demo.
	 * 
	 * @param   {Event}  e 
	 * 
	 * @return  void
	 */
	refreshDemo(e) {
		let btn = e.target.closest('.fp-demo-preview-refresh-demo');
		if (!btn) {
			return;
		}

		e.preventDefault();

		// Remove previous iframe loaded event
		this.modal.querySelector('iframe').removeEventListener('load', this.onIframeLoaded);

		this.modal.classList.add('refreshing');
		
		let iframe = this.getIFrame();

		let frame = iframe.cloneNode();

		// Add new iframe loaded event
		frame.addEventListener('load', this.onIframeLoaded.bind(this), true);

		frame.src = iframe.src;
		iframe.parentNode.replaceChild(frame, iframe);
	}

	/**
	 * Returns the IFrame.
	 * 
	 * @return  {HTMLElement}
	 */
	getIFrame() {
		return this.modal.querySelector('iframe');
	}

	/**
	 * Toggles responsive viewport buttons.
	 * 
	 * @param   {Event}  e 
	 * 
	 * @return  void
	 */
	toggleResponsiveViewport(e) {
		let btn = e.target.closest('.fp-demo-preview-responsive-device');
		if (!btn) {
			return;
		}
		
		this.setViewport(btn.dataset.device);
	}

	/**
	 * Sets preview viewport based on given device.
	 * 
	 * @param   {String}  device
	 * 
	 * @return  void
	 */
	setViewport(device) {
		let iframe = this.getIFrame();

		// Remove active class from selected device
		this.modal.querySelector('.fp-demo-preview-responsive-device.active').classList.remove('active');

		// Add active class to newly selected device
		this.modal.querySelector('.fp-demo-preview-responsive-device[data-device="' + device + '"]').classList.add('active');

		// Remove previous device
		iframe.classList.remove('desktop', 'tablet', 'mobile');

		// Add new device
		iframe.classList.add(device);
	}

	/**
	 * Show the modal.
	 * 
	 * @return  void
	 */
	showModal(templateID) {
		let templateItem = document.querySelector('.fp-demo-items .demo-item[data-id="' + templateID + '"]');
		
		document.body.classList.add('fp-demo-previewer-open');

		// Set title
		if (templateItem) {
			const templateTitle = templateItem.querySelector('.fp-demo-item-label').innerHTML;
			
			this.modal.querySelector('.fp-demo-preview-item-title').innerText = templateTitle;
			this.modal.querySelector('.fp-demo-preview-item-title').setAttribute('title', templateTitle);
		}

		/**
		 * Set Iframe
		 */
		// Get the Iframe URL
		let iframeURL = this.preview_url;

		// Set the Template ID
		iframeURL = iframeURL.replace('TEMPLATE_ID', templateID);
		if (this.modal.querySelector('iframe')) {
			let iframe = this.modal.querySelector('iframe').cloneNode();
			iframe.src = iframeURL;
			this.modal.querySelector('iframe').parentNode.replaceChild(iframe, this.modal.querySelector('iframe'));
		} else {
			// Create the iframe
			let iframe = document.createElement('iframe');
			iframe.src = iframeURL;

			// Add Iframe to the modal
			this.modal.querySelector('.fp-demo-item-preview-inner').appendChild(iframe);
		}

		// When the iframe finishes loading, stop the refresh button from rotating
		this.modal.querySelector('iframe').addEventListener('load', this.onIframeLoaded.bind(this), true);

		// Reset responsive icon
		this.setViewport('desktop');

		this.modal.classList.add('vis');
	}

	/**
	 * Hide the modal.
	 * 
	 * @return  void
	 */
	hideModal() {
		document.body.classList.remove('fp-demo-previewer-open');

		this.modal.classList.remove('vis');

		this.previewing = false;

		let iframe = this.getIFrame();
		if (iframe) {
			iframe.removeEventListener('load', this.onIframeLoaded);
			iframe.src = '';
		}
	}

	/**
	 * Close modal on escape click.
	 * 
	 * @param   {Event}  e
	 * 
	 * @return  void
	 */
	handleEscapeClose(e) {
		e = e || window.event;
		if (e.keyCode != 27) {
			return;
		}

		// If the modal is visible
		if (!this.modal.classList.contains('vis'))
		{
			return;
		}

		this.pushState(null, null, '?');
	}

	/**
	 * Updates the demos via URL.
	 * 
	 * @param   {String}  url 
	 * 
	 * @return  void
	 */
	updateFromURL(url) {
		const urlSearchParams = new URLSearchParams(url ? url : window.location.search);

		// Show/Hide Template Previewer
		if (urlSearchParams.get('id')) {
			this.showModal(urlSearchParams.get('id'));

			this.previewing = true;
		} else {
			this.hideModal();
		}
	}
}

FP_Utils.onReady(function() {
	new FP_Demos();
});